import React, { useEffect, useRef, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Divider, Input, Select, Space, Button, Form, Row, Col } from "antd";
import { request } from "../../../utils/request";
import { debounce } from "lodash";

const SelectAddCus = ({
	label = "label",
	name,
	labelCol,
	wrapperCol,
	rules,
	disabled = false,
	api = "dmnv",
	q,
	IdApp = true,
	lableOption = ["ten_nv"],
	valueOption = ["ten_nv"],
	placeholder = "custom dropdown render",
	style,
	dropdownHeight = 300,
	onChange,
}) => {
	// const [loading, setLoading] = useState(false);
	const [items, setItems] = useState([]);
	const selectSpeedRef = useRef(null);
	// const [page, setPage] = useState(1);

	useEffect(() => {
		// setPage(1);
	}, [q]);

	const handelGetData = async ({ endpoint, params }) => {
		const newIdApp = IdApp ? `${localStorage.getItem("id_app")}/` : "";
		try {
			// setLoading(true);
			const response = await request.get(`api/${newIdApp}${endpoint}`, {
				params: {
					q: JSON.stringify(params.q),
					page: 1,
					limit: 50,
				},
				headers: {
					"X-Access-Token": localStorage.getItem("token"),
					"Content-Type": "application/json",
				},
			});
			const data = response.data.map((item) => item);
			setItems(data);
			// setItems(page === 1 ? data : [...items, ...data]);
			// setPage(page + 1);
			// setLoading(false);
			return response;
		} catch (error) {
			console.log(error.message);
			// setLoading(false);
		}
	};

	const handleAddData = async (data) => {
		try {
			const response = await request.post(
				`api/${localStorage.getItem("id_app")}/${api}`,
				data,
				{
					headers: {
						"X-Access-Token": localStorage.getItem("token"),
						"Content-Type": "application/json",
					},
				}
			);
			setItems([response.data, ...items]);
			return response;
		} catch (error) {
			console.log(error.message);
		}
	};

	const handleDropdownVisibleChange = async (open) => {
		const query = {
			...q,
		};
		if (open) {
			await handelGetData({ endpoint: api, params: { q: query } });
		}
	};

	const DebouncedSearch = debounce((value) => {
		handleSearch(value);
	}, 500);

	const handleSearch = async (value) => {
		const query = {
			...q,
		};

		if (value) {
			if (!query.$or) query.$or = [];
			["ten_kh", "ma_kh"].forEach((fieldName) => {
				const fieldQuery = {};
				fieldQuery[fieldName] = {
					$regex: value,
					$options: "i",
				};
				query.$or.push(fieldQuery);
			});
		}

		await handelGetData({ endpoint: api, params: { q: query } });
	};

	const handleScroll = () => {
		const selectNode = selectSpeedRef.current;
		const { scrollTop, scrollHeight, clientHeight } = selectNode;
		if (selectNode) {
			if (scrollTop + clientHeight === scrollHeight) {
				console.log(1);
				// Đã cuộn đến cuối, gọi hàm để load thêm dữ liệu
				handelGetData({ endpoint: api, params: q });
			}
		}
	};

	const formSpeedRef = useRef(null);

	const onFinish = (values) => {
		handleAddData(values);
		onReset();
	};
	const onReset = () => {
		formSpeedRef.current?.resetFields();
	};
	return (
		<Form.Item
			name={name}
			label={label}
			labelCol={labelCol}
			wrapperCol={wrapperCol}
			rules={rules}
		>
			<Select
				ref={selectSpeedRef}
				allowClear
				disabled={disabled}
				showSearch
				style={style}
				placeholder={placeholder}
				onPopupScroll={handleScroll}
				dropdownRender={(menu) => (
					<>
						<div
							style={{
								maxHeight: dropdownHeight,
								overflowY: "auto",
								overflowX: "hidden",
							}}
						>
							{menu}
							{/* {loading && <div>Loading...</div>} */}
						</div>
						<Divider
							style={{
								margin: "8px 0",
							}}
						/>
						<Space
							style={{
								padding: "0 8px 4px",
								backgroundColor: "#fafafa",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
							}}
						>
							<Form
								id={"speed_add"}
								ref={formSpeedRef}
								name="control-ref"
								onFinish={onFinish}
							>
								<Row className="!m-0" gutter={[4, 4]}>
									{/* Tên Implant - Hãng Implant */}
									<Col span={12}>
										<Form.Item
											name="ten_kh"
											wrapperCol={{
												span: 24,
											}}
										>
											<Input
												placeholder="Nhập tên khách hàng"
												allowClear
											/>
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											name="dien_thoai"
											wrapperCol={{
												span: 24,
											}}
										>
											<Input
												placeholder="Nhập số điện thoại"
												allowClear
											/>
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											name="ghi_chu"
											wrapperCol={{
												span: 24,
											}}
										>
											<Input
												placeholder="Nhập yêu cầu khám"
												allowClear
											/>
										</Form.Item>
									</Col>
									<Col span={12}>
										<Button
											type="text"
											icon={<PlusOutlined />}
											htmlType="submit"
										>
											Tạo nhanh
										</Button>
									</Col>
								</Row>
							</Form>
						</Space>
					</>
				)}
				options={items.map((item) => ({
					value:
						valueOption && valueOption.length > 1
							? JSON.stringify(
									valueOption.reduce((acc, option) => {
										acc[option] = item[option];
										return acc;
									}, {})
							  )
							: item[valueOption[0]],
					label:
						lableOption && lableOption.length > 1
							? `${item.ho_ten_dem ?? ""} ${item.ten_kh ?? ""} (${
									item.ma_kh ?? ""
							  })`
							: item[lableOption[0]],
				}))}
				onDropdownVisibleChange={handleDropdownVisibleChange}
				onSearch={(value) => {
					DebouncedSearch(value);
				}}
				onChange={onChange}
			/>
		</Form.Item>
	);
};

export default SelectAddCus;
